var map = {
	"./bg.json": 4378,
	"./cs.json": 3571,
	"./de.json": 5894,
	"./en.json": 4174,
	"./fr.json": 4605,
	"./hu.json": 6938,
	"./it.json": 3672,
	"./nl.json": 4943,
	"./pl.json": 1029,
	"./ro.json": 2354,
	"./sv.json": 8252,
	"./tr.json": 9755
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4595;